<div class="header">
    <h2>{{ 'modules.items.dialog.title' | translate }}</h2>
    <div class="header-actions">
        @if (tab() === 'lessons') {
            <a pButton [outlined]="true" size="small" routerLink="create-lesson" data-test="dialog-select-item-create-lesson">
                <i class="pi pi-plus" pButtonIcon></i>
                <span pButtonLabel>{{ 'modules.items.dialog.createLesson' | translate }}</span>
            </a>
        } @else if (tab() === 'quizzes') {
            <a pButton [outlined]="true" size="small" routerLink="create-quiz" data-test="dialog-select-item-create-quiz">
                <i class="pi pi-plus" pButtonIcon></i>
                <span pButtonLabel>{{ 'modules.items.dialog.createQuiz' | translate }}</span>
            </a>
        } @else {
            <a pButton [outlined]="true" size="small" routerLink="create-reflection" data-test="dialog-select-item-create-reflection">
                <i class="pi pi-plus" pButtonIcon></i>
                <span pButtonLabel>{{ 'modules.items.dialog.createReflection' | translate }}</span>
            </a>
        }
        <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-select-item-close" (click)="close()">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="body">
    <div class="toggle">
        <p-button
            [label]="'modules.items.dialog.lessons' | translate"
            [outlined]="tab() !== 'lessons'"
            data-test="dialog-select-item-tab-lessons"
            (onClick)="setTab('lessons')"
        />
        <p-button
            [label]="'modules.items.dialog.quizzes' | translate"
            [outlined]="tab() !== 'quizzes'"
            data-test="dialog-select-item-tab-quizzes"
            (onClick)="setTab('quizzes')"
        />
        <p-button
            [label]="'modules.items.dialog.reflections' | translate"
            [outlined]="tab() !== 'reflections'"
            data-test="dialog-select-item-tab-reflections"
            (onClick)="setTab('reflections')"
        />
    </div>

    <app-dialog-search [placeholder]="searchPlaceholder" testId="dialog-select-item-search" (searchChange)="onSearch($event)" />

    @if (tab() === 'lessons') {
        <div class="list-container">
            @if (lessonsLoading()) {
                <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
            }
            @if (lessons().length === 0 && !lessonsLoading()) {
                <p class="empty">{{ 'modules.items.dialog.empty.lessons' | translate }}</p>
            } @else {
                <div class="list">
                    @for (item of lessons(); track item.id) {
                        <button class="item" [attr.data-test]="'dialog-select-item-lesson-' + item.id" (click)="selectLesson(item)">
                            <div class="icon" [class]="item.type">
                                <i [class]="lessonIcon(item.type)"></i>
                            </div>
                            <span class="name">{{ item.name }}</span>
                            <app-type-chip [type]="item.type" translationPrefix="lessons.type" />
                        </button>
                    }
                </div>
            }
        </div>
        <p-paginator
            [rows]="limit"
            [totalRecords]="lessonsTotal()"
            [first]="lessonsFirst()"
            data-test="dialog-select-item-lessons-paginator"
            (onPageChange)="onLessonsPageChange($event)"
        />
    } @else if (tab() === 'quizzes') {
        <div class="list-container">
            @if (quizzesLoading()) {
                <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
            }
            @if (quizzes().length === 0 && !quizzesLoading()) {
                <p class="empty">{{ 'modules.items.dialog.empty.quizzes' | translate }}</p>
            } @else {
                <div class="list">
                    @for (item of quizzes(); track item.id) {
                        <button class="item" [attr.data-test]="'dialog-select-item-quiz-' + item.id" (click)="selectQuiz(item)">
                            <div class="icon quiz">
                                <i class="pi pi-question-circle"></i>
                            </div>
                            <span class="name">{{ item.name }}</span>
                            <span class="count">{{ item.questionCount }}</span>
                        </button>
                    }
                </div>
            }
        </div>
        <p-paginator
            [rows]="limit"
            [totalRecords]="quizzesTotal()"
            [first]="quizzesFirst()"
            data-test="dialog-select-item-quizzes-paginator"
            (onPageChange)="onQuizzesPageChange($event)"
        />
    } @else {
        <div class="list-container">
            @if (reflectionsLoading()) {
                <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
            }
            @if (reflections().length === 0 && !reflectionsLoading()) {
                <p class="empty">{{ 'modules.items.dialog.empty.reflections' | translate }}</p>
            } @else {
                <div class="list">
                    @for (item of reflections(); track item.id) {
                        <button class="item" [attr.data-test]="'dialog-select-item-reflection-' + item.id" (click)="selectReflection(item)">
                            <div class="icon reflection">
                                <i class="pi pi-comments"></i>
                            </div>
                            <span class="name">{{ item.name }}</span>
                        </button>
                    }
                </div>
            }
        </div>
        <p-paginator
            [rows]="limit"
            [totalRecords]="reflectionsTotal()"
            [first]="reflectionsFirst()"
            data-test="dialog-select-item-reflections-paginator"
            (onPageChange)="onReflectionsPageChange($event)"
        />
    }
</div>
